import useMediaQuery from '@mui/material/useMediaQuery';
import mediaResolutions from '../constants/resolutions';
import {
  CART_KEY,
  TOTAL_KEY,
  TOTAL_PRICE_KEY,
} from '../constants/localStorageKeys';

export const useScreenResolution = () =>
  useMediaQuery(`(min-width:${mediaResolutions.sm})`);

export const convertToPriceFormat = (
  amount: number,
  currency: string = 'PHP',
) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  });

  return formatter.format(amount);
};

export const getLocalStorageData = () => {
  const localStoredCart = localStorage.getItem(CART_KEY);
  const localStoredCartTotal = localStorage.getItem(TOTAL_KEY);
  const localStoredCartPrice = localStorage.getItem(TOTAL_PRICE_KEY);
  const storedCartItems = localStoredCart ? JSON.parse(localStoredCart) : [];
  const storedTotal = localStoredCartTotal
    ? JSON.parse(localStoredCartTotal)
    : 0;
  const storedPrice = localStoredCartPrice
    ? JSON.parse(localStoredCartPrice)
    : 0;

  return { storedCartItems, storedTotal, storedPrice };
};
